const ERROR_CODES = {
    // Request operations
    REQUEST_CREATION_FAILED: 'Une erreur est survenue lors de la création de la demande',
    QUOTA_EXCEEDED: 'Quota atteint : impossible de créer cette demande.',
    QUOTA_WARNING: 'Quota dépassé (avertissement) : vous pouvez créer cette demande, mais vous avez déjà atteint votre quota.',
  };

  export { ERROR_CODES };
